import * as PIXI from "pixi.js";

export const calculateTextSize = (text: string, style: PIXI.TextStyle) => {
  /**
   * PIXI.TextMetrics.measureText() is a heavy operation
   * so should only call this when necessary, such as when the text or the style
   * changes.
   */
  const textMetrics = PIXI.TextMetrics.measureText(text, style);

  const { width, height } = textMetrics;

  return { width, height };
};
